var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},_vm._l((_vm.titleList),function(title,idx){return _c('p',{key:("title-" + idx),staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.buildTitleString(title, idx))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }